import React, { useContext, useState } from "react";
import axios from "axios";
import moment from "moment";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import getStorageUser from "../../../../middlewares/GetStorageUser"
import {
  Modal,
  Button,
  Header,
  Form,
  Input,
  Icon,
  Select,
  Dropdown as DropdownSemantic,
} from "semantic-ui-react";
import {
  Table,
  Dropdown as DropdownAnt,
  Menu,
  Empty,
  Radio as RadioAnt,
  Popover,
} from "antd";
import "semantic-ui-css/semantic.min.css";
import "../old.scss";
import {
  AreaOptions,
  EntidadOptions,
  LineaEstrategicaOptions,
  EstadosOptions,
} from "../../../../utils/dataSelectOptions";
import {
  edicionConvocatoria,
  idConvocatorias,
} from "../../../../redux/actions/convocatoriaAction";
import apiConvocatorias from "../../../../api/Convocatorias/api-convocatorias";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import { ModalVisualizar } from "../../ModalVisualizar/ModalVisualizar";
import { TemplateContext } from "../../../../utils/template_context";
import { useEncrypt } from "../../../../hooks/useEncrypt";
import { generarAnios } from "../../../../utils/generateYears";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { itemRenderTable } from "../../../../utils/tablaConvocatoriaHelper";

// Se renombra porque dentro del render hay un 'fechaCierre' local, el
// arreglo del filtro, que tapaba a esta funcion y la volvia no invocable.
import { fechaCierre as horaRealDeCierre } from '../../../../utils/horaCierre';

const cantidadRegistros = [
  { key: 1, value: 10, text: "10" },
  { key: 2, value: 20, text: "20" },
  { key: 3, value: 50, text: "50" },
  { key: 4, value: 100, text: "100" },
];
const coloresEstado = {
  Abierta: "#21BA45",
  "En proceso": "#EFC236",
  Cerrada: "#9F0505",
};
const tiposidentificacion = [
  { key: 3, value: 3, text: "Persona natural" },
  { key: 2, value: 2, text: "Persona jurídica" },
  { key: 1, value: 1, text: "Grupo conformado" },
];

const actualizarEstadoItem = (item, fechaactual) => {
  for (const y in item.fechas) {
    const valormin = item.fechas[y].valormin?.substring(0, 10);
    if (item.fechas[y].clave === "Apertura") {
      item.estado = moment(fechaactual).isBefore(valormin) ? "En espera" : "Abierta";
    } else if (item.fechas[y].clave === "Cierre" && moment(fechaactual).isSameOrAfter(valormin)) {
      item.estado = "Cerrada";
    } else if (item.fechas[y].clave === "Resolución de otorgamiento" && moment(fechaactual).isSameOrAfter(valormin)) {
      item.estado = "Cerrada";
    }
    if (!item.publico) item.estado = "No publicada";
  }
};

const getFechaValida = (fecha) => moment(fecha.valormax).isValid() ? moment(fecha.valormax) : moment(fecha.valormin);

const calcularEstadoConvocatoria = (convocatoria, fechaactual) => {
  if (!convocatoria.fechas) return;
  const fechas = convocatoria.fechas.sort((a, b) => moment(a.valormin) - moment(b.valormin));
  for (var y in fechas) {
    const fechavalida = getFechaValida(fechas[y]);
    if (fechas[y].clave === "Apertura") {
      convocatoria.estado = moment(fechaactual).isBefore(moment(fechas[y].valormin)) ? "En espera" : "Abierta";
    } else if (fechas[y].clave === "Cierre" && moment(fechaactual).isSameOrAfter(fechavalida)) {
      convocatoria.estado = "Cerrada";
    } else if (fechas[y].clave === "Resolución de otorgamiento" && moment(fechaactual).isSameOrAfter(fechavalida)) {
      convocatoria.estado = "Cerrada";
    }
    if (!convocatoria.publico) convocatoria.estado = "No publicada";
  }
};

export const AdminConvocatorias = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const { encrypt } = useEncrypt();
  const context = useContext(TemplateContext);
  const [years, setYears] = useState([]);

  const generateOptionsYears = () => {
    let arrayYears = [];
    const years = generarAnios();

    if (years.length > 0) {
      years.map((year, i) => { arrayYears.push({ key: i, value: year, text: year }) });
    }

    setYears(arrayYears);
  }

  //  DATOS QUE VAN HACER MOSTRADOS EN LA TABLA
  React.useEffect(() => {
    getUser();
    generateOptionsYears();
    primeroDatostabla();
    getLineasConvocatorias();
  }, []);
  const initialState = {
    datossinfiltro: [],
  };
  const initialValuesBuscarConvocatoria = {
    area: "",
    entidad: "",
    linea: "",
    tipo_participante: "",
    estado: "",
    anio: null
  };
  const [LineasConvocatorias, setLineasConvocatorias] = React.useState([]);
  const [datosActuales, setDatosActuales] = React.useState([]);
  const [principalState, setPrincipalState] = React.useState(initialState);
  const [cantidadPáginas, setCantidadPáginas] = React.useState(10);
  const [filtroAvanzado, setFiltroAvanzado] = React.useState(false);
  const [openModalBorrar, setOpenModalBorrar] = React.useState(false);
  const [nombreBorrar, setNombreBorrar] = React.useState("");
  const [idBorrar, setIdBorrar] = React.useState("");
  const [user, setUser] =  React.useState({});

  const [buscarConvocatoria, setBuscarConvocatoria] = React.useState(
    initialValuesBuscarConvocatoria
  );

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) return valueFilter[0].nombre;
    else return "";
  }

  const excluirEntidades = ['SM', 'MCM', 'PP', 'AGENDA CULTURAL'];
  const eventos = ['AGENDA CULTURAL'];


  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  const menu = (datos) => {
    return (
      <Menu>
        <Menu.Item
          key="1"
          onClick={() => abrirEditar("infoconvocatoria", datos)}
        >
          Información general
        </Menu.Item>
        <Menu.Item key="2" onClick={() => abrirEditar("cronograma", datos)}>
          Cronograma
        </Menu.Item>
        <Menu.Item key="3" onClick={() => abrirEditar("documentos", datos)}>
          Doc. administrativos
        </Menu.Item>
        <Menu.Item
          key="4"
          onClick={() => abrirEditar("documentacionTecnica", datos)}
        >
          Doc. técnicos
        </Menu.Item>
        <Menu.Item
          key="5"
          onClick={() => abrirEditar("documentacionConvocatoria", datos)}
        >
          Doc. general
        </Menu.Item>
      </Menu>
    );
  };
  const menucrear = () => {
    return (
      <Menu>
        <Menu.Item key="1" onClick={consultarconvocatioria}>
          Convocatoria
        </Menu.Item>
      </Menu>
    );
  };
  // routes
  const routes = [
    { nombre: "Convocatorias" },
    { nombre: "Tablero de Convocatorias" },
  ];
  const columns = [
    {
      title: "No.",
      width: 60,
      render: (datos, datos2, index) => {
        return (
          <span className="font-family-Montserrat-Regular">{datos.idconvocatorias}</span>
        );
      },
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: "Línea Convocatoria",
      width: 500,
      render: (datos) => {
          return (
              <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line",  fontWeight: "bold"}}>
                {getFilterLineaConvocatoria(datos?.linea_convocatoria) !== undefined ? `${getFilterLineaConvocatoria(datos?.linea_convocatoria)}` : ""}
              </span>
          );
      }
    },
    {
      title: "Nombre",
      width: 200,
      dataIndex: "nombre_convocatoria",
      key: "name",
      render: (datos) => {
        return (
          datos &&
          (datos.length > 27 ? (
            <Popover content={datos} title="Nombre Convocatoria">
              <span
                style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
              >{`${datos.substring(0, 20)}...`}</span>
            </Popover>
          ) : (
            datos
          ))
        );
      },
    },
    {
      title: "Código",
      width: 100,
      render: (datos) => (
          <span className="font-family-Montserrat-Regular">
            {datos.seq_artista}
            {datos.seq_beps}
            {datos.seq_jurado}
          </span>
      ),
    },
    {
      title: "Fecha inicio",
      width: 100,
      render: (datos) => {
        let fecha = datos.fecha_creacion;
        if (Array.isArray(datos.fechas)) {
          let fechaapertura = datos.fechas.filter(
            (data) => data.clave === "Apertura"
          );
          if (fechaapertura.length > 0) {
            fecha = fechaapertura[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Estado",
      width: 100,
      render: (datos) => {
        let fecha = datos.fechas;
        // Sin fecha de cierre que mirar, el estado es el que ya trae.
        let estadoAct = datos.estado;
        if (Array.isArray(datos.fechas)) {
          let fechaCierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );

          if (fechaCierre.length > 0) {
            fecha = fechaCierre[0].valormax

            let fechaActual = new Date();
            let anio = fechaActual.getFullYear();
            let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2)
            let dia = ('0' + fechaActual.getDate()).slice(-2);
            let hora = ('0' + fechaActual.getHours()).slice(-2);
            let minutos = ('0' + fechaActual.getMinutes()).slice(-2);

            let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;

            let cierreAct = horaRealDeCierre(fecha);
            let anioc = cierreAct.getFullYear();
            let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
            let diac = ('0' + cierreAct.getDate()).slice(-2);
            let horac = ('0' + cierreAct.getHours()).slice(-2);
            let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
            let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

            if (fechaYHoraActualizada <= fechaYHora) {
              estadoAct = 'Cerrada';
            }
          }
        }
        return (<span style={{ color: coloresEstado[estadoAct], marginLeft: "0" }}>
                  {estadoAct}
                </span>)
      },
    },
    {
      title: () => "Publicada",
      width: 150,
      render: (datos, datos2, index) => (
          <RadioAnt.Group
            value={datos.publico}
            onChange={(e) => {
              apiConvocatorias.cambiarestadoPublicoConvocatorias(
                datos.idconvocatorias,
                e.target.value
              );
              const infoupdate = [...datosActuales];
              const fechaactual = moment().format("YYYY-MM-DD");
              infoupdate[index].publico = e.target.value;
              datos.publico = e.target.value;
              for (var i in infoupdate) {
                actualizarEstadoItem(infoupdate[i], fechaactual);
              }
              return setDatosActuales(infoupdate);
            }}
          >
            <RadioAnt value={true}>Sí</RadioAnt>
            <RadioAnt value={false}>No</RadioAnt>
          </RadioAnt.Group>
      ),
    },
    {
      title: "Entidad",
      width: 100,
      dataIndex: "entidad",
      key: "entidad",
    },
    {
      title: "Línea estratégica",
      width: 200,
      dataIndex: "linea_estrategica",
      key: "linea_estrategica",
      render: (datos) => {
        return (
          datos &&
          (datos.length > 27 ? (
            <Popover content={datos} title="Línea estratégica">
              <span
                style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}
              >{`${datos.substring(0, 26)}...`}</span>
            </Popover>
          ) : (
            datos
          ))
        );
      },
    },
    {
      title: "Creado por",
      width: 220,
      dataIndex: "usuario_creacion",
      key: "usuario_creacion",
    },
    {
      title: () => (
        <div>
          <div className="titleAcciones">Acciones</div>
          <div className="controls">
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Ver
            </div>
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Editar
            </div>
            <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
              Borrar
            </div>
          </div>
        </div>
      ),
      width: 100,
      key: "operations",
      fixed: context.device === "lg" ? "right" : false,
      render: (datos) => (
        <div className="controls">
          <Button
            className="botones-acciones"
            icon="eye"
            onClick={() => openVisualizar(datos)}
          />
          {datos.tipo === 1 ? (
            <DropdownAnt.Button
              onClick={(e) => abrirEditar("cronograma", datos)}
              overlay={() => menu(datos)}
              className="button-ant-ant"
              icon={<Icon name="pencil" />}
            />
          ) : datos.tipo === 2 ? (
            <DropdownAnt.Button
              onClick={(e) => abrirEditar("cronograma", datos)}
              overlay={() => menu(datos)}
              className="button-ant-ant"
              icon={<Icon name="pencil" />}
            />
          ) : datos.tipo === 3 ? (
            <DropdownAnt.Button
              onClick={(e) => abrirEditar("cronograma", datos)}
              overlay={() => menu(datos)}
              className="button-ant-ant"
              icon={<Icon name="pencil" />}
            />
          ) : null}
          <Button
            className="botones-acciones boton-borrar-adminconvocatorias"
            icon="trash alternate outline"
            onClick={(e) => abrirmodalEliminar(e, datos)}
          />
        </div>
      ),
    },
  ];
  const [openModal, setOpenModal] = useState(false);
  const [convocatoria, setConvocatoria] = useState({});
  const openVisualizar = (datos) => {
    setConvocatoria(datos);
    setOpenModal(true);
  };
  const primeroDatostabla = async () => {
    try {
      const token = localStorage.getItem('token')
      let response = await axios.get(
        `${process.env.REACT_APP_SERVER_CONV}convocatorias/`,
        {
          headers: {
            'Authorization': token
          }
        }
      );
      let fechaactual = moment()
      
      response.data.convocatorias = response.data.convocatorias.filter(
        (data) => data.activo !== false
      );

      for (var i in response.data.convocatorias) {
        calcularEstadoConvocatoria(response.data.convocatorias[i], fechaactual);
      }
      
      if (response.data.convocatorias.length > 0) {
        setPrincipalState({ datossinfiltro: response.data.convocatorias });
        let copy = response.data.convocatorias.map((data) => data);
        setDatosActuales(copy);
      } else {
        setDatosActuales([]);
        setPrincipalState({ datossinfiltro: [] });
      }
    } catch (error) {
      return console.error(error);
    }
  };
  function mostrarConvocatorias(event, value) {
    return setCantidadPáginas(value);
  }
  function filtradodeinformacion(e) {
    let filtrado = principalState.datossinfiltro.filter(
      (data) =>
          getFilterLineaConvocatoria(data.linea_convocatoria)
          .toLowerCase()
          .indexOf(e.target.value.toLowerCase()) >= 0
    );
    let datos = filtrado;
    setDatosActuales(datos);
    return setCantidadPáginas(10);
  }
  function abrirmodalEliminar(e, value) {
    setNombreBorrar(value.numero_convocatoria);
    setIdBorrar(value.idconvocatorias);
    return setOpenModalBorrar(!openModalBorrar);
  }
  async function borrarConvocatoria() {
    const token = localStorage.getItem('token');

    try {
      await axios.put(
        `${process.env.REACT_APP_SERVER_CONV}convocatorias/cambiarEstadoConvocatoria/${idBorrar}`,
        {
          activo: false,
        },
        {
          headers: {
            'Authorization': token
          }
        }
      );
      let copy = datosActuales.map((data) => data);
      let eliminar = copy.filter((data) => data.idconvocatorias !== idBorrar);
      setDatosActuales(eliminar);
      return setOpenModalBorrar(!openModalBorrar);
    } catch (error) {
      console.error(error);
      return;
    }
  }
  function abrirEditar(route, datos, pestaña) {
    dispatch(edicionConvocatoria(true));
    dispatch(idConvocatorias(datos.idconvocatorias));
    localStorage.setItem(
      "id_convocatoria",
      encrypt(datos.idconvocatorias.toString())
    );
    localStorage.setItem("editar_convocatoria", encrypt("true"));
    if (datos.tipo === 1) {
      return history(`/Administrador/${route}`);
    }
    if (datos.tipo === 2) {
      localStorage.setItem("cambiarPestaña", encrypt(pestaña));
      return history(`/Administrador/infoconvocatoria`);
    }
    if (datos.tipo === 3) {
      localStorage.setItem("cambiarPestaña", encrypt(pestaña));
      return history(`/Administrador/infoconvocatoria`);
    }
    return history(`/Administrador/${route}`);
  }

  const consultarconvocatioria = async () => {
    localStorage.removeItem("editar_convocatoria");
    history("/administrador/infoconvocatoria");
  };
  const cambiarFiltro = (e) => {
    return setBuscarConvocatoria({
      ...buscarConvocatoria,
      [e.input]: e.value,
    });
  };
  const limpiarFiltros = () => {
    setBuscarConvocatoria(initialValuesBuscarConvocatoria);
    return setDatosActuales(principalState.datossinfiltro);
  };
  const filtrarConvocatorias = () => {
    let filtro = principalState.datossinfiltro;
    if (
      buscarConvocatoria.tipo_participante &&
      buscarConvocatoria.tipo_participante !== ""
    ) {
      filtro = filtro.filter((x) => {
        for (var i in x.tipo_participante) {
          if (
            x.tipo_participante[i].value ===
            buscarConvocatoria.tipo_participante
          ) {
            return x;
          }
        }
      });
    }
    if (buscarConvocatoria.area && buscarConvocatoria.area !== "") {
      filtro = filtro.filter((x) => {
        for (var i in x.area) {
          if (x.area[i].value === buscarConvocatoria.area) {
            return x;
          }
        }
      });
    }
    if (buscarConvocatoria.linea && buscarConvocatoria.linea !== "") {
      filtro = filtro.filter(
        (x) => x.linea_estrategica === buscarConvocatoria.linea
      );
    }
    if (buscarConvocatoria.estado && buscarConvocatoria.estado !== "") {
      filtro = filtro.filter((x) => x.estado === buscarConvocatoria.estado);
    }
    if (buscarConvocatoria.entidad && buscarConvocatoria.entidad !== "") {
      filtro = filtro.filter((x) => x.entidad === buscarConvocatoria.entidad);
    }
    if (
      buscarConvocatoria.anio &&
      buscarConvocatoria.anio !== null
    ) {
      filtro = filtro.filter((x) => {
        if (
            moment(x.fecha_creacion).format('YYYY') ===
            String(buscarConvocatoria.anio)
          ) {
            return x;
          }
      });
    }
    return setDatosActuales(filtro);
  };


  return (
    <div className="background-color-F7FBFF height-100">
      <div className="col-12 background-color-101c31 ">
        <BreadCrumbAdmin routes={routes} />
      </div>

      <div className="container-fluid ps-md-4 pe-md-4 main-c2">
        <div className="d-flex title_out_card  justify-content-between pe-0">
          <div className="font-family-Montserrat-SemiBold font-size-14px">
            Gestionar convocatorias
          </div>
          <div
            className="container-pagination-adminconvocatorias justify-content-flex-end 
   "
          >
            <DropdownAnt overlay={menucrear} placement="bottomRight">
              <Button
                className="no-margin text-nowrap button-azul-ghost tamaño-botton-admin-convocatoria justify-content-flex-end Custom-ul-li"
                style={{
                  padding: "0",
                  textAlign: "right !important",

                }}
              >
                Crear convocatoria
                <Icon
                  className="padding-left-icono-admin-convocatoria ms-2 me-md-0"
                  size="large"
                  name="plus circle"
                />
              </Button>
            </DropdownAnt>
          </div>
        </div>

        <div className="sombra_card" style={{ marginBottom: "50px" }}>
          <div className="header_card">
            <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
              {" "}
              Lista de Convocatorias{" "}
              <span className="font-size-10px  font-family-Montserrat-Regular font-color-DB2828"></span>
            </div>
          </div>
          <div className="body_card">
            <div className="row">
              <div className="col-12 col-md-6 justify-content-flex-start  order-0 font-size-14px font-family-Montserrat-Regular">
                <div className="row g-2">
                  <div className="col-11 align-items-center align-content-center pb-3">
                    <Input
                      icon="search"
                      placeholder="Buscar Nombre/Código"
                      className="font-family-Work-Sans font-size-14px border-color-707070 border-radius-5px font-color-051923bf"
                      fluid
                      onChange={filtradodeinformacion}
                    />
                  </div>
                  <div className="col-1 align-items-center justify-content-flex-center">
                    <Button
                      icon="filter"
                      className="button-filtro-adminconvocatorias"
                      onClick={() => setFiltroAvanzado(!filtroAvanzado)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 d-flex justify-content-md-end justify-content-between align-content-center align-items-center mb-3">
                <div className="d-flex justify-content-end">
                  <div>
                    Total:{" "}
                    <span className="font-color-F28C02">
                      {datosActuales.length}
                    </span>
                  </div>
                </div>

                <div
                  className="d-flex justify-content-end registos-adminconvocatoria"
                  style={{ width: 200 }}
                >
                  <label className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                    Registros por página
                  </label>
                  <DropdownSemantic
                    className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                    defaultValue={cantidadPáginas}
                    options={cantidadRegistros}
                    icon={
                      <Icon
                        className="font-color-051923bf iconos-dropdown-global"
                        name="angle down"
                      />
                    }
                    onChange={(e, { value }) => mostrarConvocatorias(e, value)}
                  />
                </div>
              </div>
            </div>
            {filtroAvanzado ? (
              <div>
                <div className="row container-grid-filtros">
                  <div className="col-12 pb-2">
                    <Form>
                      <Form.Group widths="equal">
                        <Form.Field>
                          <label className="font-color-4B4B4B font-size-12px pb-2">
                            Tipo participante
                          </label>
                          <Select
                            placeholder="Seleccionar..."
                            value={buscarConvocatoria.tipo_participante}
                            options={tiposidentificacion}
                            onChange={(e, { value }) =>
                              cambiarFiltro({
                                e,
                                value,
                                input: "tipo_participante",
                              })
                            }
                          />
                        </Form.Field>
                        <Form.Field>
                          <label className="font-color-4B4B4B font-size-12px pb-2">
                            Entidad
                          </label>
                          <Select
                            className="font-family-Work-Sans"
                            icon={
                              <Icon
                                style={{ float: "right" }}
                                className="font-color-051923bf iconos-select-global"
                                name="angle down"
                              />
                            }
                            value={buscarConvocatoria.entidad}
                            placeholder="Seleccionar..."
                            options={EntidadOptions}
                            onChange={(e, { value }) =>
                              cambiarFiltro({ e, value, input: "entidad" })
                            }
                          />
                        </Form.Field>
                        <Form.Field>
                          <label className="font-color-4B4B4B font-size-12px pb-2">
                            Línea estratégica
                          </label>
                          <Select
                            className="font-family-Work-Sans"
                            icon={
                              <Icon
                                style={{ float: "right" }}
                                className="font-color-051923bf iconos-select-global"
                                name="angle down"
                              />
                            }
                            value={buscarConvocatoria.linea}
                            placeholder="Seleccionar..."
                            options={LineaEstrategicaOptions}
                            onChange={(e, { value }) =>
                              cambiarFiltro({ e, value, input: "linea" })
                            }
                          />
                        </Form.Field>
                        <Form.Field>
                          <label className="font-color-4B4B4B font-size-12px pb-2">
                            Área
                          </label>
                          <Select
                            className="font-family-Work-Sans"
                            icon={
                              <Icon
                                style={{ float: "right" }}
                                className="font-color-051923bf iconos-select-global"
                                name="angle down"
                              />
                            }
                            placeholder="Seleccionar..."
                            value={buscarConvocatoria.area}
                            options={AreaOptions}
                            label={
                              <label className="font-color-4B4B4B">Área</label>
                            }
                            onChange={(e, { value }) =>
                              cambiarFiltro({ e, value, input: "area" })
                            }
                          />
                        </Form.Field>
                        <Form.Field>
                          <label className="font-color-4B4B4B font-size-12px pb-2">
                            Año
                          </label>
                          <Select
                            className="font-family-Work-Sans"
                            icon={
                              <Icon
                                style={{ float: "right" }}
                                className="font-color-051923bf iconos-select-global"
                                name="angle down"
                              />
                            }
                            placeholder="Seleccionar..."
                            value={buscarConvocatoria.anio}
                            options={years}
                            label={
                              <label className="font-color-4B4B4B">Área</label>
                            }
                            onChange={(e, { value }) =>
                              cambiarFiltro({ e, value, input: "anio" })
                            }
                          />
                        </Form.Field>
                        <Form.Field>
                          <label className="font-color-4B4B4B font-size-12px pb-2">
                            Estado
                          </label>
                          <Select
                            className="font-family-Work-Sans"
                            icon={
                              <Icon
                                style={{ float: "right" }}
                                className="font-color-051923bf iconos-select-global"
                                name="angle down"
                              />
                            }
                            placeholder="Seleccionar..."
                            value={buscarConvocatoria.estado}
                            options={EstadosOptions}
                            label={
                              <label className="font-color-4B4B4B">
                                Estado
                              </label>
                            }
                            onChange={(e, { value }) =>
                              cambiarFiltro({ e, value, input: "estado" })
                            }
                          />
                        </Form.Field>
                      </Form.Group>
                    </Form>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 d-flex justify-content-end pb-3">
                    <Button
                      className="button-azul-ghost"
                      onClick={limpiarFiltros}
                    >
                      Limpiar filtros
                    </Button>
                    <Button
                      className="button-azul-radius"
                      onClick={filtrarConvocatorias}
                    >
                      Buscar
                    </Button>
                  </div>
                </div>
              </div>
            ) : null}
            <div className="col-12">
              <div className="row">
                <div className="col">
                  <Table
                    style={{ borderTop: "1px solid #C4C4C4" }}
                    locale={{
                      emptyText: (
                        <Empty

                          description="No se han diligenciados datos para está sección"
                          style={{ padding: "50px" }}

                        />
                      ),
                    }}
                    pagination={{
                      position: ["bottomRight"],
                      itemRender: itemRenderTable,
                      pageSize: cantidadPáginas,
                    }}
                    columns={columns}
                    dataSource={datosActuales?.filter(
                      (fila) => !excluirEntidades.includes(fila.entidad)
                    )}
                    scroll={{ x: 1500, y: 300 }}
                    size="small"
                    rowClassName="sizeTable table-row"
                    className="table-ant-design-modify"
                    bordered={false}
                  />
                </div>
              </div>
              {
              user.documento == '1152462177' && (
                  <div className="row">
                    <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                      Todas las entidades{" "}
                      <span className="font-size-10px  font-family-Montserrat-Regular font-color-DB2828"></span>
                    </div>
                  <div className="col">
                    <Table
                      style={{ borderTop: "1px solid #C4C4C4" }}
                      locale={{
                        emptyText: (
                          <Empty

                            description="No se han diligenciados datos para está sección"
                            style={{ padding: "50px" }}

                          />
                        ),
                      }}
                      pagination={{
                        position: ["bottomRight"],
                        itemRender: itemRenderTable,
                        pageSize: cantidadPáginas,
                      }}
                      columns={columns}
                      dataSource={datosActuales?.filter(
                        (fila) => !eventos.includes(fila.entidad)
                      )}
                      scroll={{ x: 1500, y: 300 }}
                      size="small"
                      rowClassName="sizeTable table-row"
                      className="table-ant-design-modify"
                      bordered={false}
                    />
                  </div>
                </div>
              )}
              {
              (user.documento == '1152462177' || user.documento == '1128439760') && (
                  <div className="row">
                    <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                      Agenda cultural{" "}
                      <span className="font-size-10px  font-family-Montserrat-Regular font-color-DB2828"></span>
                    </div>
                  <div className="col">
                    <Table
                      style={{ borderTop: "1px solid #C4C4C4" }}
                      locale={{
                        emptyText: (
                          <Empty

                            description="No se han diligenciados datos para está sección"
                            style={{ padding: "50px" }}

                          />
                        ),
                      }}
                      pagination={{
                        position: ["bottomRight"],
                        itemRender: itemRenderTable,
                        pageSize: cantidadPáginas,
                      }}
                      columns={columns}
                      dataSource={datosActuales?.filter(
                        (fila) => eventos.includes(fila.entidad)
                      )}
                      scroll={{ x: 1500, y: 300 }}
                      size="small"
                      rowClassName="sizeTable table-row"
                      className="table-ant-design-modify"
                      bordered={false}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal dimmer={'inverted'} open={openModalBorrar} id="modal_convocatoria" size="small">
        <Modal.Description>
          <div className="container-titulos-modal-actividades">
            <Header className="containar-header-eliminar-adminconvocatoria">
              Eliminar convocatoria
            </Header>
            <Header className="container-subheader-eliminar-adminconvocatoria">
              Esta a punto de eliminar la convocatoria seleccionada
            </Header>
            <Header className="container-subheader-eliminar-adminconvocatoria">
              ¿Desea eliminarla?
            </Header>
            <Header className="container-convocatoria-eliminar-adminconvocatoria">
              {nombreBorrar}
            </Header>
          </div>
        </Modal.Description>
        <Modal.Actions>
          <div className="contenido-acciones-modal-actividades" centered>
            <Button
              className="button-blanco-radius"
              basic
              color="blue"
              onClick={() => setOpenModalBorrar(!openModalBorrar)}
            >
              Cancelar
            </Button>
            <Button
              className="button-azul-radius"
              color="blue"
              onClick={borrarConvocatoria}
            >
              Sí, eliminar
            </Button>
          </div>
        </Modal.Actions>
      </Modal>
      {openModal && (
        <ModalVisualizar
          openModal={openModal}
          setOpenModal={setOpenModal}
          convocatoria={convocatoria}
        />
      )}
    </div>
  );
};
